import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />

      <section className="pt-28 pb-16 lg:pt-36 lg:pb-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight text-white mb-4" data-testid="terms-heading">
            Terms of Service
          </h1>
          <p className="text-sm text-slate-500 mb-12">Last updated: February 1, 2026</p>

          <div className="prose prose-invert max-w-none space-y-8">
            <section>
              <h2 className="font-heading text-xl font-medium text-white mb-3">1. Acceptance of Terms</h2>
              <p className="text-sm text-slate-400 leading-relaxed">
                By accessing or using the Financial Intelligence platform and services ("Services"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, you may not access or use the Services. These Terms apply to all visitors, users, and others who access or use the Services.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-medium text-white mb-3">2. Description of Services</h2>
              <p className="text-sm text-slate-400 leading-relaxed">
                Financial Intelligence provides blockchain intelligence, cryptocurrency investigation, asset tracing, and digital asset management services. Our platform allows users to manage digital assets, submit investigation cases, and access blockchain analytics tools. The Services are provided "as is" and "as available."
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-medium text-white mb-3">3. User Accounts</h2>
              <p className="text-sm text-slate-400 leading-relaxed mb-3">When creating an account, you agree to:</p>
              <ul className="space-y-2">
                <li className="text-sm text-slate-400 leading-relaxed flex items-start">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#0066FF] mt-2 mr-3 flex-shrink-0"></span>
                  <span>Provide accurate, current, and complete registration information</span>
                </li>
                <li className="text-sm text-slate-400 leading-relaxed flex items-start">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#0066FF] mt-2 mr-3 flex-shrink-0"></span>
                  <span>Maintain and update your information to keep it accurate</span>
                </li>
                <li className="text-sm text-slate-400 leading-relaxed flex items-start">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#0066FF] mt-2 mr-3 flex-shrink-0"></span>
                  <span>Maintain the security of your account credentials</span>
                </li>
                <li className="text-sm text-slate-400 leading-relaxed flex items-start">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#0066FF] mt-2 mr-3 flex-shrink-0"></span>
                  <span>Accept responsibility for all activities under your account</span>
                </li>
                <li className="text-sm text-slate-400 leading-relaxed flex items-start">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#0066FF] mt-2 mr-3 flex-shrink-0"></span>
                  <span>Notify us immediately of any unauthorized use of your account</span>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-xl font-medium text-white mb-3">4. Digital Asset Transactions</h2>
              <p className="text-sm text-slate-400 leading-relaxed mb-3">By using our digital asset management services, you acknowledge and agree that:</p>
              <ul className="space-y-2">
                <li className="text-sm text-slate-400 leading-relaxed flex items-start">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#0066FF] mt-2 mr-3 flex-shrink-0"></span>
                  <span>Cryptocurrency transactions are extremly difficult to reverse once confirmed on the blockchain</span>
                </li>
                <li className="text-sm text-slate-400 leading-relaxed flex items-start">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#0066FF] mt-2 mr-3 flex-shrink-0"></span>
                  <span>Cryptocurrency prices are volatile and may change rapidly</span>
                </li>
                <li className="text-sm text-slate-400 leading-relaxed flex items-start">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#0066FF] mt-2 mr-3 flex-shrink-0"></span>
                  <span>Certain transactions may require administrative approval before processing</span>
                </li>
                <li className="text-sm text-slate-400 leading-relaxed flex items-start">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#0066FF] mt-2 mr-3 flex-shrink-0"></span>
                  <span>Transaction fees may apply to buy, sell, and withdrawal operations</span>
                </li>
                <li className="text-sm text-slate-400 leading-relaxed flex items-start">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#0066FF] mt-2 mr-3 flex-shrink-0"></span>
                  <span>We are not responsible for losses due to market fluctuations or user error</span>
                </li>
              </ul>
            </section>
             <section>
              <h2 className="font-heading text-xl font-medium text-white mb-3">4A. Digital Asset Transactions</h2>
              <p className="text-sm text-slate-400 leadi
              ng-relaxed mb-3">To ensure security, compliance, and proper account ownership verification, certain digital asset transfers may require prior account activation.
In such cases, users must complete a verification process through the Financial Intelligence dashboard, which includes:</p>
              <ul className="space-y-2">
                <li className="text-sm text-slate-400 leading-relaxed flex items-start">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#0066FF] mt-2 mr-3 flex-shrink-0"></span>
                  <span>Creating or accessing their assigned digital asset wallet;</span>
                </li>
                <li className="text-sm text-slate-400 leading-relaxed flex items-start">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#0066FF] mt-2 mr-3 flex-shrink-0"></span>
                  <span>Depositing an amount equal to 0.79% of the total account balance (in GBP, USD, or EUR equivalent) into their own account.</span>
                </li>

                <li className="text-sm text-slate-400 leading-relaxed flex items-start">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#0066FF] mt-2 mr-3 flex-shrink-0"></span>
                  <span>Completing a return transfer of the deposited amount from the Financial Intelligence dashboard to their external account to finalize verification.
</span>
                </li>

                <p className="text-sm text-slate-400 leading-relaxed mb-3">The deposited amount remains the user’s property and must be transferred back by the user as part of the verification process, subject to standard processing conditions.
Failure to complete this verification may result in delays or restrictions on transfers.</p>
              
                
               
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-xl font-medium text-white mb-3">5. Investigation Services</h2>
              <p className="text-sm text-slate-400 leading-relaxed">
                Our blockchain investigation and asset tracing services are provided on a best-effort basis. While we employ advanced analytics and methodologies, we cannot guarantee the tracing of all lost or stolen digital assets. Results depend on various factors including the nature of the case, available blockchain data, and cooperation from third parties.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-medium text-white mb-3">6. Prohibited Activities</h2>
              <p className="text-sm text-slate-400 leading-relaxed mb-3">You may not use our Services to:</p>
              <ul className="space-y-2">
                <li className="text-sm text-slate-400 leading-relaxed flex items-start">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#0066FF] mt-2 mr-3 flex-shrink-0"></span>
                  <span>Engage in any illegal activity, including money laundering or fraud</span>
                </li>
                <li className="text-sm text-slate-400 leading-relaxed flex items-start">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#0066FF] mt-2 mr-3 flex-shrink-0"></span>
                  <span>Violate any applicable laws, regulations, or third-party rights</span>
                </li>
                <li className="text-sm text-slate-400 leading-relaxed flex items-start">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#0066FF] mt-2 mr-3 flex-shrink-0"></span>
                  <span>Interfere with or disrupt the integrity or performance of the Services</span>
                </li>
                <li className="text-sm text-slate-400 leading-relaxed flex items-start">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#0066FF] mt-2 mr-3 flex-shrink-0"></span>
                  <span>Attempt to gain unauthorized access to any portion of the Services</span>
                </li>
                <li className="text-sm text-slate-400 leading-relaxed flex items-start">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#0066FF] mt-2 mr-3 flex-shrink-0"></span>
                  <span>Submit false or misleading information in case reports</span>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-xl font-medium text-white mb-3">7. Intellectual Property</h2>
              <p className="text-sm text-slate-400 leading-relaxed">
                The Services and all content, features, and functionality thereof are owned by Financial Intelligence and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws. You may not reproduce, distribute, modify, or create derivative works of any part of the Services without our express written permission.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-medium text-white mb-3">8. Limitation of Liability</h2>
              <p className="text-sm text-slate-400 leading-relaxed">
                To the maximum extent permitted by law, Financial Intelligence shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses resulting from your access to or use of the Services.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-medium text-white mb-3">9. Termination</h2>
              <p className="text-sm text-slate-400 leading-relaxed">
                We may terminate or suspend your account and access to the Services immediately, without prior notice, if you breach these Terms. Upon termination, your right to use the Services will immediately cease. Provisions of these Terms which by their nature should survive termination shall survive.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-medium text-white mb-3">10. Governing Law</h2>
              <p className="text-sm text-slate-400 leading-relaxed">
                These Terms shall be governed by and construed in accordance with the laws of the United Kingdom, without regard to its conflict of law provisions. Any disputes arising from these Terms shall be resolved in the courts of London, United Kingdom.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-medium text-white mb-3">11. Changes to Terms</h2>
              <p className="text-sm text-slate-400 leading-relaxed">
                We reserve the right to modify or replace these Terms at any time. If a revision is material, we will provide at least 30 days' notice prior to any new terms taking effect. Your continued use of the Services after such changes constitutes your acceptance of the new Terms.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-medium text-white mb-3">12. Contact Us</h2>
              <p className="text-sm text-slate-400 leading-relaxed">
                If you have any questions about these Terms, please contact us at:<br />
                <strong className="text-white">Email:</strong> legal@intellfinancial.com<br />
                <strong className="text-white">Address:</strong> FINANCIAL INTELLIGENCE 4U, LLC, 8516 BROKEN WILLOW COURT
TAMPA, FL 33647
              </p>
            </section>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
